import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgGlassesFuturistic = function SvgGlassesFuturistic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "glasses-futuristic_svg__icon glasses-futuristic_svg__icon--glasses-futuristic"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.25 15.849a6 6 0 0 1-6 6h-1.782a1.9 1.9 0 0 1-1.652-.974l-1.116-3.79a.749.749 0 0 0-1.4 0l-1.115 3.79a1.9 1.9 0 0 1-1.653.974H6.75a6 6 0 0 1-6-6v-1.5a3 3 0 0 1 3-3h16.5a3 3 0 0 1 3 3v1.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m1.661 11.349 2.96-6.987A2.347 2.347 0 0 1 6.751 3 2.25 2.25 0 0 1 9 5.25M22.339 11.349l-2.96-6.987A2.347 2.347 0 0 0 17.25 3 2.25 2.25 0 0 0 15 5.25"
  })));
};

export { SvgGlassesFuturistic as default };
//# sourceMappingURL=glasses-futuristic.svg.js.map
